import $ from 'jquery';

$(function () {
    if ($('#contact_us_correspondent_page').length) {
        $(document).ready(function () {
            $('#rm1-text').css('display', 'none');
            $('#rm2-text').css('display', 'none');
            $('#rm3-text').css('display', 'none');
            $('#rm4-text').css('display', 'none');
            $('#rm5-text').css('display', 'none');
            $('#rm6-text').css('display', 'none');
            $('#rm7-text').css('display', 'none');
        });

        $('#rm1').click(function () {
            $('#rm1-text').css('display','block');
            $('#rm1').css('display', 'none');
            $('#rm1-less').css('display', 'none');
        });
        $('#rm2').click(function () {
            $('#rm2-text').css('display', 'block');
            $('#rm2').css('display', 'none');
            $('#rm2-less').css('display', 'none');
        });
        $('#rm3').click(function () {
            $('#rm3-text').css('display', 'block');
            $('#rm3').css('display', 'none');
            $('#rm3-less').css('display', 'none');
        });
        $('#rm4').click(function () {
            $('#rm4-text').css('display', 'block');
            $('#rm4').css('display', 'none');
            $('#rm4-less').css('display', 'none');
        });
        $('#rm5').click(function () {
            $('#rm5-text').css('display', 'block');
            $('#rm5').css('display', 'none');
            $('#rm5-less').css('display', 'none');
        });
        $('#rm6').click(function () {
            $('#rm6-text').css('display', 'block');
            $('#rm6').css('display', 'none');
            $('#rm6-less').css('display', 'none');
        });
        $('#rm7').click(function () {
            $('#rm7-text').css('display', 'block');
            $('#rm7').css('display', 'none');
            $('#rm7-less').css('display', 'none');
        });
    }
});